module.exports = __webpack_public_path__ + "img/B_Head-or-Tail.fc05b1ac.png";